export const version = {
  formId: "connector-version",
  formField: {
    releaseNotes: {
      name: "releaseNotes",
      label: "Release notes",
      type: "editor",
      placeholder: "eg. Release notes"
    },
    configFile: {
      name: "configFile",
      label: "upload package",
      type: "file",
      placeholder: "",
      errorMsg: "Connector files are required."
    }
  }
};
